import { Edit } from '@mui/icons-material'
import { Button } from '@mui/material'

interface EditButtonProps {
  disabled?: boolean
  onEdit: () => void
  text?: string
}

export default function EditButton({ disabled, onEdit, text = 'EDIT' }: EditButtonProps) {
  return (
    <Button color='primary' disabled={disabled} endIcon={<Edit />} onClick={onEdit} variant='text'>
      {text}
    </Button>
  )
}
